import createComponent from '@carvana/merch-components/createComponent';
import cx from 'classnames';

export const ShadedBackground = createComponent('div', {
  className: cx(
    'col-span-full row-span-full h-full w-full',
    '[background-image:linear-gradient(351deg,rgba(0,0,0,0.00)_24.2%,rgba(0,0,0,0.60)_104.81%)]',
    'md:[background-image:linear-gradient(287deg,rgba(0,0,0,0.00)_36.99%,rgba(0,0,0,0.34)_67.35%,rgba(0,0,0,0.60)_101.97%)]',
    'lg:[background-image:linear-gradient(271deg,rgba(0,0,0,0.00)_35.46%,rgba(0,0,0,0.60)_119.23%)]'
  )
});

export const LowerSection = createComponent('div', {
  className: cx(
    /* colors */ 'bg-background-muted-strong text-text-inverse-subtle',
    /* padding */ 'px-2xl py-4xl sm:py-5xl md:px-3xl md:py-7xl lg:px-4xl'
  )
});

export const TilesWrapper = createComponent('div', {
  className: cx(
    /* grid */ 'grid md:grid-cols-2 md:grid-rows-2 lg:grid-cols-[1fr_auto_1fr_auto_1fr_auto_1fr] lg:grid-rows-1',
    /* gap */ 'gap-y-2xl md:gap-x-40 md:gap-y-4xl lg:gap-x-4xl',
    /* max-width */ 'mx-auto max-w-[1272px]',
    /* everything else */ 'lg:justify-items-center'
  )
});

export const Tile = createComponent('div', {
  className: 'flex flex-col gap-y-lg'
});

export const TileHeading = createComponent('h2', {
  className: 't-heading-md'
});

export const TileText = createComponent('p', {
  className: 't-body-sm'
});

export const TileDivider = createComponent('div', {
  className: cx(
    'h-[1px] w-full bg-border-inverse-transparent opacity-20 md:hidden lg:block lg:h-full lg:w-[1px]'
  )
});
